
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/races-runners/[level2]",
      function () {
        return require("private-next-pages/races-runners/[level2]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/races-runners/[level2]"])
      });
    }
  